import { DEFAULT_DASH_LANGUAGE, DashLanguages } from "dash-common";

type SignupLanguageInput = {
  enabled: boolean;
  pick?: DashLanguages | null;
  browser?: DashLanguages | null;
};

// Sent even while the switcher is hidden, so new accounts already carry the
// visitor's language when it launches.
export const resolveSignupLanguage = ({
  enabled,
  pick,
  browser,
}: SignupLanguageInput): DashLanguages =>
  (enabled ? pick : null) ?? browser ?? DEFAULT_DASH_LANGUAGE;
